<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'

import { playerTitle } from '@player/_lib/playerTitle'
import { props as propDefinition } from './props'
import { useClient } from '@base/api/useClient'

// Props
const props = defineProps(propDefinition)

// Static Variables
const client = useClient()
const router = useRouter()
const route = useRoute()
useHead({
  title: playerTitle('Cancellation Policy')
})

// Inputs

// Outputs
const loading = ref<boolean>(false)
const serverError = ref<boolean>(false)

// Helper Functions
const reset = () => {
  loading.value = false
  serverError.value = false
}

// Query Functions
const fetchData = async () => {
  reset()

  // Prepare Inputs + any Formating

  // Validate Inputs (optional, mainly for validating form inputs)

  // Fetch Data
  try {
    loading.value = true

    // const { data } = await client.query<...>({
    //  query: ...,
    //  variables: {
    //    page: page.value
    //  }
    // })

    // if (data...) {
    //   // Handle Success
    //  courses.value = data...
    // } else {
    //   // Handle Errors
    //   serverError.value = true
    // }
  } catch (e) {
    console.error(e)
    serverError.value = true
  } finally {
    loading.value = false
  }
}

// Mutation Functions

// User Interaction Handlers

// Initial Data Fetch

// Fetch Data when the URL changes the props
watch(props, async () => {
  await fetchData()
})

// Fetch data when the view is first rendered
await fetchData()
</script>

<template>
  <div class="cancellation-policy">
    <div class="grid__row">
      <div class="grid__column grid__column--12">
        <h1 class="cancellation-policy__heading heading--h2">
          Cancellation Policy
        </h1>
        <p class="cancellation-policy__body body--p1--regular">
          Any bookings made through UpSwing are subject to UpSwing’s 10-Day
          Cancellation Policy. Any bookings made 10 days or more prior to the
          scheduled tee time or event are fully refundable. For any booking
          cancellations within 10 days of your scheduled tee time or event, your
          funds will be automatically deemed non-refundable.
        </p>
        <br />
        <p class="cancellation-policy__body body--p1--regular">
          You may inquire with individual golf clubs for their internal rain
          check policies, subject to the clubs’ individual discretion.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cancellation-policy {
  min-height: calc(100vh - var(--player-header-height));

  &__heading {
    margin-bottom: var(--spacing--6);
  }
}
</style>
